import { Injectable } from '@angular/core';
import { Product, Category, CategoryResponse, CategoryItems, Paging} from './products/product';
import { Query } from './query';
import { HttpClient, HttpHeaders, HttpParams , HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../environments/environment';

import { from } from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import {switchMap, mergeMap,flatMap, take, mergeAll, combineAll, map, toArray, mapTo, tap} from 'rxjs/operators';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import {Configuration} from './configuration';
import { WindowRefService, ICustomWindow } from './window-ref.service';

@Injectable()
export class ConfigurationService {
  private apiUrl: string  = '/api';
  private _configuration:Configuration;
  private configurationSubject: BehaviorSubject<Configuration> =  new BehaviorSubject<Configuration>({});
  private _window: ICustomWindow;

  constructor(
    windowRef: WindowRefService,
    private http: HttpClient
  ) {
    this.apiUrl = `${environment.serverUrl}/api`;
    this._window = windowRef.nativeWindow;
  }

  getConfigurationSubject(): Observable<Configuration>{
    return this.configurationSubject;
  }

  setLicense(data: Query): Observable<Configuration>{


    // const httpOptions = {
    //   params: this.queryToSearchParams({mac_address: data.mac_address})
    // };

return  this.http.get(`${this.apiUrl}/users/set_license/${data.license}`)
.pipe(
  switchMap(() => this.getConfiguration(false) ),
  tap((config: Configuration) => {
    // Side effect, if we get the license back then also call the skp url
    if (config && config.license) {
      // this._window.location.href = `skp:on_license_store@${config.license}`
    }

  }),
   catchError(this.handleError)
  );
  }

  setConfiguration(configuration: Configuration): void{
    this._configuration = configuration;
  }

  getConfigurationCache(): Configuration {
    return this._configuration || {};
  }


  getConfiguration(fromCache?: boolean): Observable<Configuration>{



     if (this._configuration && fromCache) {
      this.configurationSubject.next(this._configuration);

     } else {

      this.http.get<Configuration>(`${this.apiUrl}/config`)
      .pipe(
       catchError(this.handleError)
        ).subscribe((data:Configuration)=> {
          this._configuration = data; //data
          this.configurationSubject.next(this._configuration);
         });

     }

     return this.configurationSubject;


  }

  queryToSearchParams(filter: Query) {
    let params = new HttpParams();

    if (filter.license) {
      params = params.append('license', filter.license.toString());
    }

    if (filter.mac_address) {
      params = params.append('mac_address', filter.mac_address.toString());
    }



    return params;
  }

  private handleError(error: HttpErrorResponse) {

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      'Something bad happened; please try again later.');
  };


}



// WEBPACK FOOTER //
// ./src/app/configuration.service.ts